module.exports = __webpack_public_path__ + "images/f97116b357c186d26c9f8f866c621f9a-trendingImg1.png";